import { render, staticRenderFns } from "./sliding-panel.vue?vue&type=template&id=6785160c&"
import script from "./sliding-panel.vue?vue&type=script&lang=ts&"
export * from "./sliding-panel.vue?vue&type=script&lang=ts&"
import style0 from "./sliding-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports